import type { VideoItem } from "@/types";
import { videoList } from "@/mocks/videos";

export function getAllVideos(): VideoItem[] {
  return videoList;
}

export function getVideoById(id: string): VideoItem | undefined {
  return videoList.find((v) => v.id === id);
}

export function getVideosByType(type: string): VideoItem[] {
  return videoList.filter((v) => v.type === type);
}

export interface FilterParams {
  type?: string;
  genre?: string;
  region?: string;
  year?: string;
  sort?: string;
  keyword?: string;
}

function sortVideos(items: VideoItem[], sort?: string): VideoItem[] {
  const list = [...items];
  if (sort === "newest") {
    return list.sort((a, b) => b.year - a.year || b.hot - a.hot);
  }
  if (sort === "rating") {
    return list.sort((a, b) => b.rating - a.rating);
  }
  return list.sort((a, b) => b.hot - a.hot);
}

export function filterVideos(params: FilterParams): VideoItem[] {
  const { type, genre, region, year, sort, keyword } = params;
  let result = videoList.slice();

  if (type && type !== "all") {
    result = result.filter((v) => v.type === type);
  }
  if (genre && genre !== "全部") {
    result = result.filter((v) => v.genres.includes(genre));
  }
  if (region && region !== "全部") {
    result = result.filter((v) => v.region === region);
  }
  if (year && year !== "全部") {
    result = result.filter((v) => String(v.year) === year);
  }
  if (keyword) {
    const kw = keyword.trim().toLowerCase();
    if (kw) {
      result = result.filter(
        (v) =>
          v.title.toLowerCase().includes(kw) ||
          v.genres.join(" ").toLowerCase().includes(kw) ||
          v.cast.join(" ").toLowerCase().includes(kw) ||
          v.director.toLowerCase().includes(kw) ||
          v.tags.join(" ").toLowerCase().includes(kw) ||
          v.summary.toLowerCase().includes(kw)
      );
    }
  }
  return sortVideos(result, sort);
}

export function searchVideos(keyword: string): VideoItem[] {
  return filterVideos({ keyword });
}

export function getRelatedVideos(video: VideoItem, count = 4): VideoItem[] {
  const others = videoList.filter((v) => v.id !== video.id);
  const sameGenre = others.filter((v) => v.genres.some((g) => video.genres.includes(g)));
  const sameType = others.filter(
    (v) => v.type === video.type && !sameGenre.includes(v)
  );
  const rest = others.filter((v) => !sameGenre.includes(v) && !sameType.includes(v));

  const ordered = [...sameGenre, ...sameType, ...rest];
  return ordered.slice(0, count);
}

export function getHotVideos(count = 6): VideoItem[] {
  return [...videoList].sort((a, b) => b.hot - a.hot).slice(0, count);
}